import React from 'react'
import { Box, Button, Grid } from '@material-ui/core'
import EvgmTranslationText from '../shared/EvgmTranslationText'

function SubmittedEvgmButtonComponent(props){

    const evgmTranslatedTextsObject = EvgmTranslationText()

    return(
        <Box pl={5} pr={5} pt={4} pb={4}>
          <Grid container xs={12} sm={12}>
            <Grid container xs={12} sm={12} justify='flex-end' spacing={2}>
              <Box>
                <Button
                  variant='contained'
                  className='button-blue originalText'
                  onClick={() => {
                    props.buttonAction()
                  }}
                >
                  {evgmTranslatedTextsObject.backToMyEvgm}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
    )
}

export default SubmittedEvgmButtonComponent